import {connect} from 'react-redux'
import {bindActionCreators } from 'redux'
import * as actions from 'actions'
import SelectSyaryougaisunLength from 'components/site/select_syaryougaisun_length'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

const mapStateToProps = state => ({
  systemLabelMastersApi: state.systemLabelMastersApi,
  selectSyaryougaisunLengthStart: state.searchFormCondition.selectSyaryougaisunLengthStart,
  selectSyaryougaisunLengthFinish: state.searchFormCondition.selectSyaryougaisunLengthFinish,
})

const SyaryougaisunLengthContainer = connect(mapStateToProps, mapDispatchToProps)(SelectSyaryougaisunLength)

export default SyaryougaisunLengthContainer
